






















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { store, CDR, StoreState,Timezone } from '../../store';
import { mapState } from 'vuex';
import Sidebar from "../../components/Sidebar.vue";
import { ErrorDescription } from 'msal/lib-commonjs/Constants';
import ContactMesageDetail from './contactmessageinfo.vue';
import ContactDetailInformation from './contactdetailinfo.vue';
import Textmessages from './textmessages.vue'
import util from '../../lib/util';

 @Component({
  components: {
   Sidebar,Textmessages,ContactMesageDetail,ContactDetailInformation
  } ,
  computed: {
		...mapState({
		 'textpannel_contactinfo': (state: StoreState) => state.dashboard.textpannel_contactinfo ,
		 
		}),
	},mounted: function() {
        }
   
 })
 export default class CallMessageHistory extends Vue {
    
 data() {
 return {    
 }
 }
  
  
 }

